import { render, staticRenderFns } from "./CreateProduct copy.vue?vue&type=template&id=2712b78e&scoped=true&"
import script from "./CreateProduct copy.vue?vue&type=script&lang=js&"
export * from "./CreateProduct copy.vue?vue&type=script&lang=js&"
import style0 from "./CreateProduct copy.vue?vue&type=style&index=0&id=2712b78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712b78e",
  null
  
)

component.options.__file = "CreateProduct copy.vue"
export default component.exports